import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useGetSubscribersQuery } from '../../../redux/features/subscribersSlice';

function SubscriberCard() {
    const [, setLastWeekCount] = useState(0);
    const [, setThisWeekCount] = useState(0);
    const[differenceCount, setDifferenceCount] = useState(0);
    const [percentageChange, setPercentageChange] = useState(0);
    const {data:subcribers} = useGetSubscribersQuery()
    
    useEffect(() => {
      async function fetchBlogData() {
        try {
          const currentDate = new Date();
    
          // Calculate the start of last week
          const lastWeekStartDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - 7
          );
    
          // Calculate the start of this week
          const thisWeekStartDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() - currentDate.getDay()
          );
    
          // Ensure that subcribers is not undefined before filtering
          if (subcribers) {
            // Filter subscribers created last week
            const lastWeekBlogs = subcribers.filter(blog => {
              const createdAt = new Date(blog.createdAt);
              return createdAt >= lastWeekStartDate && createdAt < thisWeekStartDate;
            });
    
            // Filter subscribers created this week
            const thisWeekBlogs = subcribers.filter(blog => {
              const createdAt = new Date(blog.createdAt);
              return createdAt >= thisWeekStartDate && createdAt < currentDate;
            });
    
            // Update the state with the counts
            setLastWeekCount(lastWeekBlogs.length);
            setThisWeekCount(thisWeekBlogs.length);
            setDifferenceCount(thisWeekBlogs.length - lastWeekBlogs.length);
    
            // Calculate percentage change
            if (lastWeekBlogs.length !== 0) {
              const percentage = ((thisWeekBlogs.length - lastWeekBlogs.length) / lastWeekBlogs.length) * 100;
              setPercentageChange(percentage);
            } else {
              // Handle division by zero when lastWeekCount is 0
              setPercentageChange(thisWeekBlogs.length === 0 ? 0 : 100);
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    
      fetchBlogData();
    }, [subcribers]);
    
    
  return (
    <div className="w-[230px] max-w-[278px] shadow-primaryShadow border bg-white border-[#F5F5FA] rounded-2xl px-5 py-3">
          <div className="flex items-center gap-2">
          <span className="w-8 h-8 flex items-center justify-center bg-[#E9FAEB] rounded">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="17"
                viewBox="0 0 15 17"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.1287 1.2149L11.1295 1.8146C13.3332 1.98731 14.789 3.48896 14.7913 5.79181L14.8 12.5324C14.8032 15.0432 13.2258 16.588 10.6975 16.592L4.52153 16.6C2.00898 16.6032 0.411878 15.0216 0.408718 12.5036L0.40003 5.84218C0.39687 3.52414 1.80125 2.02649 4.00496 1.82419L4.00417 1.2245C4.00338 0.872671 4.26404 0.608004 4.61158 0.608004C4.95912 0.607204 5.21977 0.871072 5.22056 1.2229L5.22135 1.78262L9.91313 1.77622L9.91234 1.2165C9.91155 0.864675 10.1722 0.600808 10.5197 0.600008C10.8594 0.599208 11.1279 0.863076 11.1287 1.2149ZM1.61721 6.08926L13.5757 6.07327V5.79341C13.5418 4.07427 12.6792 3.17232 11.1311 3.03799L11.1319 3.65368C11.1319 3.99751 10.8641 4.27017 10.5245 4.27017C10.1769 4.27097 9.9155 3.99911 9.9155 3.65528L9.91471 3.0076L5.22293 3.014L5.22372 3.66087C5.22372 4.0055 4.96385 4.27737 4.61631 4.27737C4.26877 4.27817 4.00733 4.0071 4.00733 3.66247L4.00654 3.04678C2.46631 3.20111 1.61405 4.10625 1.61642 5.84058L1.61721 6.08926ZM10.192 9.72344V9.73223C10.1998 10.1001 10.5 10.3791 10.8641 10.3711C11.2196 10.3623 11.5031 10.0577 11.4952 9.68986C11.4786 9.33803 11.1935 9.05098 10.8388 9.05177C10.4755 9.05977 10.1912 9.35562 10.192 9.72344ZM10.8444 13.3136C10.481 13.3056 10.188 13.0026 10.1872 12.6348C10.1793 12.267 10.4708 11.9623 10.8341 11.9535H10.842C11.2132 11.9535 11.5142 12.2566 11.5142 12.6324C11.515 13.0082 11.2148 13.3128 10.8444 13.3136ZM6.93772 9.73623C6.95352 10.104 7.25445 10.3911 7.61779 10.3751C7.97323 10.3583 8.25679 10.0545 8.24099 9.68666C8.2323 9.32684 7.94005 9.04698 7.58462 9.04778C7.22128 9.06377 6.93693 9.36842 6.93772 9.73623ZM7.62095 13.2777C7.25761 13.2937 6.95747 13.0066 6.94088 12.6388C6.94088 12.271 7.22444 11.9671 7.58778 11.9503C7.94321 11.9495 8.23625 12.2294 8.24415 12.5884C8.26074 12.957 7.97639 13.2609 7.62095 13.2777ZM3.68349 9.76422C3.69928 10.132 4.00022 10.4199 4.36356 10.4031C4.719 10.3871 5.00256 10.0825 4.98597 9.71464C4.97807 9.35482 4.68582 9.07496 4.32959 9.07576C3.96626 9.09175 3.6827 9.3964 3.68349 9.76422ZM4.36672 13.2817C4.00338 13.2984 3.70323 13.0106 3.68665 12.6428C3.68586 12.275 3.97021 11.9703 4.33354 11.9543C4.68898 11.9535 4.98202 12.2334 4.98992 12.5932C5.00651 12.961 4.72294 13.2657 4.36672 13.2817Z"
                  fill="#0DA06A"
                />
              </svg>
            </span>
            <p className="text-[#344054] text-sm font-semibold">Subscribers</p>
          </div>
          
          <p className="text-[#344054] font-semibold text-xl mt-5 sm:mt-7">
          {Math.abs(differenceCount)}
          </p>
          {percentageChange === 0 ? 
           <div className="flex w-full  justify-end  gap-x-3 items-center">
           <svg
             xmlns="http://www.w3.org/2000/svg"
             width="10"
             height="10"
             viewBox="0 0 10 10"
             fill="none"
             className="rotate-90"
           >
             <path d="M5 0L9.33013 7.5H0.669873L5 0Z" fill="#e4d00a" />
           </svg>
           <span className="text-[#e4d00a] text-xs font-medium">
             {Math.abs(percentageChange)}%
           </span>
           <svg
             xmlns="http://www.w3.org/2000/svg"
             width="74"
             height="28"
             viewBox="0 0 74 28"
             fill="none"
           >
             <path
               d="M1 2V28H73V4L62 3L54.5 4L36 1.5L19.5 3.5L1 2Z"
               fill=""
               className="fill-[#EEDC82] opacity-40"
 
             />
             <path
               d="M1 1.75L19.5 3.25L36 1L54.5 4L62 2.5L73 4"
               stroke="#e4d00a"
             />
             <defs>
               <linearGradient
                 id="paint0_linear_16424_42803"
                 x1="37"
                 y1="2"
                 x2="37"
                 y2="28"
                 gradientUnits="userSpaceOnUse"
               >
                 <stop stopColor="#D946EF" />
                 <stop offset="1" stopColor="#D946EF" stopOpacity="0" />
               </linearGradient>
             </defs>
           </svg>
         </div>:
           <div className="w-full flex justify-end">
           {percentageChange > 0 ?
            <div className="flex items-center gap-3">
           <svg
             xmlns="http://www.w3.org/2000/svg"
             width="10"
             height="10"
             viewBox="0 0 10 10"
             fill="none"
           >
             <path d="M5 0L9.33013 7.5H0.669873L5 0Z" fill="#0DA06A" />
           </svg>
           <span className="text-[#0DA06A] text-xs font-medium">{Math.abs(percentageChange)}%</span>
           <svg
             xmlns="http://www.w3.org/2000/svg"
             width="75"
             height="30"
             viewBox="0 0 75 30"
             fill="none"
           >
             <path
               d="M22.3626 2.11204C16.033 0.917639 5.48352 10.0747 1 14.8025V30H73V2.11204C70.3626 4.8492 61.9231 13.3095 50.0549 10.3235C35.5095 6.66391 30.2747 3.60503 22.3626 2.11204Z"
               fill="url(#paint0_linear_16359_2484)"
             />
             <path
               d="M1.79102 14.0559C6.0108 9.57691 16.3493 0.91753 23.9449 2.11193C33.4394 3.60492 35.7739 8.35924 52.4284 10.3234C65.0877 11.8164 71.6811 4.10259 72.9998 2.11193"
               stroke="#0DA06A"
               strokeWidth="2.04"
               strokeLinecap="round"
             />
             <defs>
               <linearGradient
                 id="paint0_linear_16359_2484"
                 x1="37"
                 y1="2.00565"
                 x2="36.5"
                 y2="30"
                 gradientUnits="userSpaceOnUse"
               >
                 <stop stopColor="#8EF6D0" />
                 <stop offset="1" stopColor="#8EF6D0" stopOpacity="0" />
               </linearGradient>
             </defs>
           </svg>
         </div>: 
              <div className="flex items-center gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path d="M5 10L9.33013 2.5H0.669873L5 10Z" fill="#F34A7C" />
              </svg>
              <span className="text-[#F34A7C] text-xs font-medium">{Math.abs(percentageChange)}%</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="75"
                height="29"
                viewBox="0 0 75 29"
                fill="none"
              > 
                <path
                  d="M52 4C58.3297 2.8056 68.5165 9.07471 73 13.8025V29H1V1.11206C3.63736 3.84922 12.5549 6.17651 24 6.00002C38.997 5.76877 44.0879 5.493 52 4Z"
                  fill="url(#paint0_linear_16359_248)"
                />
                <path
                  d="M72.9998 13.0559C68.78 8.57693 57.5956 3.3056 50 4.5C40.5055 5.993 39.1545 3.53583 22.5 5.5C9.84066 6.993 3.10965 3.1026 1.79097 1.11194"
                  stroke="#F34A7C"
                  strokeWidth="2.04"
                  strokeLinecap="round"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_16359_248"
                    x1="37"
                    y1="1.00568"
                    x2="37.5"
                    y2="28.5"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#FCD9E3" />
                    <stop offset="1" stopColor="#FCD9E3" stopOpacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
           }
       </div>
          }
         
          <small className='text-[10px] inline-flex justify-end pt-3 ml-20 text-gray-400'>Compared to last week</small>

        </div>
  )
 
}

export default SubscriberCard